<template>
    <div>
        <h1>
            <el-page-header @back="goBack" :content="secondLiveActivity.name.concat('素材')">
            </el-page-header>
        </h1>
        <el-card class="form-container" shadow="never">
            <el-button type="primary" @click="showDetails('添加素材')">添加素材</el-button>
        </el-card>
        <el-card class="form-container" shadow="never">
            <el-table border
                      :data="materialList"
                      height="690"
                      style="width: 100%">
                <el-table-column label="序号" prop="id" align="center"></el-table-column>
                <el-table-column  label="素材图片"  align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.image" width="60px" height="60px" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column  label="颜色"  align="center">
                    <template slot-scope="scope" >
                    <el-input size="small" :min="0" style="width: 110px" v-model="scope.row.color"  @change="update(scope.row)" ></el-input>
                    </template >
                </el-table-column>
                <el-table-column  label="排序"  align="center">
                    <template slot-scope="scope" >
                        <el-input-number size="small" :min="0" style="width: 110px" v-model="scope.row.ranking"  @change="update(scope.row)" ></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column  label="操作"  align="center">
                    <template slot-scope="scope" >
                        <el-button plain size="mini" type="danger" @click="remove(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="1234px" :before-close="cancel">
            <el-form :model="materialForm" >
                <el-form-item label="上传素材:" >
                    <el-upload
                            :headers="headers"
                            class="upload-demo"
                            :action="uploadURL"
                            :on-success="handleImageSuccess"
                            :on-remove="handleImgRemove"
                            :before-upload="beforeImageUpload"
                            :file-list="formatImages"
                            list-type="picture-card">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="颜色:" >
                    <el-input  style="width: 300px" type="text" v-model="materialForm.color"></el-input>
                </el-form-item>
            </el-form>

            <h1 style="text-align: center;">
                <el-button type="primary" @click="confirm">确 定</el-button>
                <el-button type="info" @click="cancel">取 消</el-button>
            </h1>

        </el-dialog>

    </div>
</template>

<script>
    import {
        searchLiveActivityImage,
        updateLiveActivityImage,
        saveLiveActivityImage,
        deleteLiveActivityImage
    }from "@/http/iosApi";
    export default {
        name: "SelectAppLink",
        data(){
            return{
                headers: {},
                uploadURL: process.env.VUE_APP_IOS_URL + "block/upload",
                secondLiveActivity: {},
                materialForm:{},
                formatImages:[],
                materialList:[],
                VUE_APP_CDN_URL:'',
                dialogTitle:'',
                multipleSelection: [],
                dialogVisible : false,
                selectForm :{},
            }
        },
        methods:{
            goBack() {
                    this.$router.push({path: '/secondLiveActivity' });
            },
            handleImageSuccess(data) {
                var temp={name:null,url:null,postUrl:null};
                var url=data.info
                var array=url.split('/');
                temp.name=array[array.length-1];
                temp.url=process.env.VUE_APP_CDN_URL +url
                temp.postUrl=url;
                this.formatImages.push(temp);

            },
            beforeImageUpload(data) {
                const type = data.name.substring(data.name.lastIndexOf('.')) === '.png' || data.name.substring(data.name.lastIndexOf('.')) === '.jpg';
                const size = data.size < 1024 * 1024 * 5;
                if (!type) {
                    this.$message.error('上传图片只能是png,jgp格式!');
                }
                if (!size) {
                    this.$message.error('上传图片大小不能超过500MB!');
                }
                return type && size;
            },
            handleImgRemove(file){
                const name = file.name
                const i = this.formatImages.findIndex(x => x.name === name)

                this.formatImages.splice(i, 1)
            },

            queryList(){
                searchLiveActivityImage(this.secondLiveActivity.id).then(resp => {
                    this.materialList = resp.data.info;
                })
            },
            showDetails(title) {
                this.dialogTitle = title;
                this.dialogVisible = true;
            },
            remove(id){
                this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteLiveActivityImage(id).then(resp=> {
                        if (resp.data.status === 0) {
                            this.queryList()
                        }
                    });
                }).catch(() => {
                    this.queryList()
                })
            },

            confirm(){
                if(this.formatImages.length>0){
                    let tempImages=[];
                    this.formatImages.forEach(item=>{
                        tempImages.push(item.postUrl);
                    })
                    this.materialForm.images=tempImages;
                }
                this.materialForm.liveActivityId = this.secondLiveActivity.id;
                let _message = '';
                if(this.materialForm.images === '' || this.materialForm.images.length<1){
                    _message = '请上传图片'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveLiveActivityImage(this.materialForm).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogVisible=false;
                        this.queryList();
                    }
                });
            },
            cancel(){
                this.dialogVisible=false;
            },
            update(row){
                this.selectForm = {
                    "id" : row.id,
                    "ranking" :row.ranking,
                    "liveActivityId" : row.liveActivityId,
                    "image" : row.image,
                    "color": row.color
                };

                updateLiveActivityImage(this.selectForm).then(resp=> {
                    if (resp.data.status===0){
                        this.queryList();
                    }
                })
            }
        },
        created() {
            this.secondLiveActivity = this.$store.state.secondLiveActivity;
            this.queryList();
        },
        mounted() {
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>

</style>